module.exports = __webpack_public_path__ + "img/browser-edge.fde633eb.svg";